module.exports = __webpack_public_path__ + "static/assets/683c810cb12f00cc5720ca08c63c6fdb.png";